var slider = new Swiper('.tab-slider', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    loopedSlides: 6,
    allowTouchMove: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

});

var thumbs = new Swiper('.tab-thumbs', {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: false,
    slideToClickedSlide: true,
    allowTouchMove: false,
    breakpoints: {
        // when window width is <= 480px
        0: {
            spaceBetween: 10
        },
        // when window width is <= 768px
        768: {
            spaceBetween: 30
        },
        // when window width is <= 1024px
        1024: {
            spaceBetween: 40
        },
        // when window width is <= 1200px
        1200: {
            spaceBetween: 50
        },
        // when window width is > 1200px
        1201: {
            spaceBetween: 60
        }
    }
});


slider.controller.control = thumbs;
thumbs.controller.control = slider;

// Slider 2
var slider2 = new Swiper('.tab-slider2', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    loopedSlides: 6,
    allowTouchMove: false,
});

var thumb2 = new Swiper('.tab-thumbs2', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: true,
    loop: false,
    slideToClickedSlide: true,
    allowTouchMove: false,
    breakpoints: {
        // when window width is <= 480px
        0: {
            spaceBetween: 10
        },
        // when window width is <= 768px
        768: {
            spaceBetween: 30
        },
        // when window width is <= 1024px
        1024: {
            spaceBetween: 40
        },
        // when window width is <= 1200px
        1200: {
            spaceBetween: 50
        },
        // when window width is > 1200px
        1201: {
            spaceBetween: 60
        }
    }
});

slider2.controller.control = thumb2;
thumb2.controller.control = slider2;

// Slider 3
var slider3 = new Swiper('.tab-slider3', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    loopedSlides: 6,
    allowTouchMove: false,
});

var thumb3 = new Swiper('.tab-thumbs3', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: true,
    loop: false,
    slideToClickedSlide: true,
    allowTouchMove: false,
    breakpoints: {
        // when window width is <= 480px
        0: {
            spaceBetween: 10
        },
        // when window width is <= 768px
        768: {
            spaceBetween: 30
        },
        // when window width is <= 1024px
        1024: {
            spaceBetween: 40
        },
        // when window width is <= 1200px
        1200: {
            spaceBetween: 50
        },
        // when window width is > 1200px
        1201: {
            spaceBetween: 60
        }
    }
});

slider3.controller.control = thumb3;
thumb3.controller.control = slider3;

// Slider 4
var slider4 = new Swiper('.tab-slider4', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    loopedSlides: 6,
    allowTouchMove: false,
});

var thumb4 = new Swiper('.tab-thumbs4', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: true,
    loop: false,
    slideToClickedSlide: true,
    allowTouchMove: false,
    breakpoints: {
        // when window width is <= 480px
        0: {
            spaceBetween: 10
        },
        // when window width is <= 768px
        768: {
            spaceBetween: 30
        },
        // when window width is <= 1024px
        1024: {
            spaceBetween: 40
        },
        // when window width is <= 1200px
        1200: {
            spaceBetween: 50
        },
        // when window width is > 1200px
        1201: {
            spaceBetween: 60
        }
    }
});

slider4.controller.control = thumb4;
thumb4.controller.control = slider4;

// Slider 5
var slider5 = new Swiper('.tab-slider5', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    loopedSlides: 6,
    allowTouchMove: false,
});

var thumb5 = new Swiper('.tab-thumbs5', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: true,
    loop: false,
    slideToClickedSlide: true,
    allowTouchMove: false,
    breakpoints: {
        // when window width is <= 480px
        0: {
            spaceBetween: 10
        },
        // when window width is <= 768px
        768: {
            spaceBetween: 30
        },
        // when window width is <= 1024px
        1024: {
            spaceBetween: 40
        },
        // when window width is <= 1200px
        1200: {
            spaceBetween: 50
        },
        // when window width is > 1200px
        1201: {
            spaceBetween: 60
        }
    }
});

slider5.controller.control = thumb5;
thumb5.controller.control = slider5;

// Slider 6
var slider6 = new Swiper('.tab-slider6', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    loopedSlides: 6,
    allowTouchMove: false,
});

var thumb6 = new Swiper('.tab-thumbs6', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: true,
    loop: false,
    slideToClickedSlide: true,
    allowTouchMove: false,
    breakpoints: {
        // when window width is <= 480px
        0: {
            spaceBetween: 10
        },
        // when window width is <= 768px
        768: {
            spaceBetween: 30
        },
        // when window width is <= 1024px
        1024: {
            spaceBetween: 40
        },
        // when window width is <= 1200px
        1200: {
            spaceBetween: 50
        },
        // when window width is > 1200px
        1201: {
            spaceBetween: 60
        }
    }
});

slider6.controller.control = thumb6;
thumb6.controller.control = slider6;